"use client"

import React, { useEffect, useRef, useState } from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

import style from "./otpInputBox.module.css"

interface IOtp_inputBox {
  state: string
  setState: React.Dispatch<React.SetStateAction<string>>
  warnMsg?: string
  className?: string
  length: number
  errorMsg?: string
  verificationState?: null | "success" | "error"
}
const RE_DIGIT = new RegExp(/^\d+$/)

function OtpBox({
  state,
  length,
  setState,
  warnMsg,
  className,
  errorMsg,
  verificationState,
}: IOtp_inputBox) {
  const [otp, setOtp] = useState({})
  const [err, setErr] = useState("")
  const otpInputBoxref = useRef<HTMLDivElement | undefined>()

  useEffect(() => {
    if (!state && otpInputBoxref) {
      if (otpInputBoxref?.current) {
        setOtp(state)
        const otpInputs = otpInputBoxref.current.querySelectorAll("input")
        otpInputs?.[0].focus() // taking focus to 0 th position when the state becomes null
        otpInputs.forEach((input, _) => {
          input.value = null
        })
      }
    }
  }, [state])

  useEffect(() => {
    setErr(errorMsg)
  }, [errorMsg])

  useEffect(() => {
    setState(Object.values(otp).join(""))
  }, [otp])

  useEffect(() => {
    if (otpInputBoxref?.current) {
      const otpInputs: NodeListOf<HTMLInputElement> =
        otpInputBoxref.current?.querySelectorAll("input")

      otpInputs.forEach((input, index) => {
        input.addEventListener("input", (event: Event) => {
          const value = (event.target as HTMLInputElement).value

          if (value.length === 1 && value !== " ") {
            if (index < otpInputs.length - 1) {
              otpInputs[index + 1].focus()
            }
          }
        })

        input.addEventListener("keydown", (event: KeyboardEvent) => {
          if (event.key === "Backspace" && !input.value) {
            if (index > 0) {
              otpInputs[index - 1].focus()
            }
          }
        })
      })
    }
  }, [otpInputBoxref])

  const getTheStyle = (type: string | null) => {
    switch (type) {
      case "success": {
        return "border-green-700 border"
      }

      case "error": {
        return "border-orange-700 border"
      }

      default: {
        return ""
      }
    }
  }

  return (
    <div
      className="otp-input-box flex justify-center flex-col h-full"
      ref={otpInputBoxref}
    >
      <div className="flex justify-center flex-wrap gap-1 h-12">
        {length
          ? Array.from({ length: length }, () => 1).map((id, _) => (
              <BlurWrapper
                className={`min-w-[24px] flex-1 h-full rounded-lg  ${getTheStyle(verificationState)}`}
                overlayColorDefault="light"
                overlayOpacityDefault="20"
              >
                <input
                  key={_}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  autoComplete="one-time-code"
                  pattern="\d{1}"
                  id={`digit${_ + 1}`}
                  className={`w-auto text-center p-1  flex-1 ${style.inputBoxOtp} ${className}`}
                  size={1}
                  onChange={(e) => {
                    // update;
                    if (!RE_DIGIT.test(e.target.value)) {
                      setErr("Please enter a valid OTP")
                      e.target.value = null
                      return
                    } else if (e.target.value === " ") {
                      setErr("Can't take space as input")
                      e.target.value = null
                      return
                    } else {
                      setErr("")
                      setOtp({ ...otp, [_]: e.target.value })
                    }
                  }}
                  title={warnMsg}
                  required
                />
              </BlurWrapper>
            ))
          : null}
      </div>
      {/* {err && (
        <div
          className={`text-[red] text-left font-medium text-xs py-1 ${style.errBox}`}
        >
          {err}
        </div>
      )} */}
    </div>
  )
}

export default OtpBox
